import React, { useState, useEffect, useRef} from 'react';
import './Footer.css';
import {Typography, Box} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {FacebookRounded, Instagram, LinkedIn} from "@mui/icons-material";
import XIcon from "./XIcon";

const Footer = () => {
    const navigate = useNavigate();
    const footerRef = useRef(null);
    const [isBoxOpen, setIsBoxOpen] = useState(false);
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // The footer is fixed to the bottom of the viewport, so publish its height for the body padding and page-height CSS
    useEffect(() => {
        const footer = footerRef.current;
        const publishHeight = () => {
            const height = footer.getBoundingClientRect().height;
            document.documentElement.style.setProperty('--footer-height', `${Math.ceil(height)}px`);
        };

        publishHeight();
        const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(publishHeight) : null;
        resizeObserver?.observe(footer);

        return () => {
            resizeObserver?.disconnect();
            document.documentElement.style.removeProperty('--footer-height');
        };
    }, []);

    const handleClickOutside = (event) => {
        const targetClass = event.target.className;
        if (typeof targetClass === "string" && !targetClass.includes('box') && !targetClass.includes('footer-item-right')) {
            setIsBoxOpen(false);
        }
    };

    const toggleBox = () => {
        setIsBoxOpen(!isBoxOpen);
    };

    return (
        <Box ref={footerRef} className="footer container-fluid" sx={{ backgroundColor: 'primary.main',
            '& .MuiTypography-root': {
                color: 'primary.text', // make sure this key is defined in your theme
            }
        }} >
            <Box className="row">
                <Box className="col-sm column">
                    <Box sx={{marginTop: "2px"}}>

                        <Typography fontSize={12}  onClick={()=>{navigate("/terms")}} className="footer-item">
                            Terms
                        </Typography>
                        <Typography fontSize={12} onClick={()=>{navigate("/privacy")}} className="footer-item">
                            Privacy
                        </Typography>
                        <Typography fontSize={12} onClick={()=>{navigate("/business-terms")}} className="footer-item">
                            Business Terms
                        </Typography>

                        {/*<Typography onClick={()=>{navigate("/privacy-choice")}} className="footer-item">*/}
                        {/*    Privacy Choice*/}
                        {/*</Typography>*/}
                    </Box>

                    <Box sx={{marginTop: "2px", marginRight:"10px"}}>

                        <Typography fontSize={12} className="copyright" sx={{paddingLeft: 0, display: 'unset',
                            '@media (max-width:475px)': {
                                display: 'none'
                            },
                        }} >
                            © {new Date().getFullYear()} Pair Tech LLC
                        </Typography>
                        <FacebookRounded sx={{height:"20px", color: 'primary.text', verticalAlign: 'middle',  cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/paircare.a.i', '_blank')} />
                        <Instagram sx={{height:"20px", color: 'primary.text', verticalAlign: 'middle',  cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/paircare.a.i', '_blank')} />
                        <XIcon sx={{height:"20px", color: 'primary.text', verticalAlign: 'middle',  cursor: 'pointer' }} onClick={() => window.open('https://x.com/paircare_ai', '_blank')} />
                        <LinkedIn sx={{height:"20px", color: 'primary.text', verticalAlign: 'middle',  cursor: 'pointer' }} onClick={() => window.open('https://www.linkedin.com/in/paircare/', '_blank')} />
                    </Box>
                    <Box sx={{marginTop: "2px"}} className="help-center" >
                        <Typography fontSize={12} onClick={() => { window.location.assign("/sitemap.xml"); }} className="footer-item" >
                            Sitemap
                        </Typography>
                        <Typography fontSize={12}
                           className={'footer-item-right'}
                           onClick={toggleBox}
                        >
                            Help
                        </Typography>
                        {isBoxOpen && (
                            <Box sx={{backgroundColor: 'sub.main',
                                '& .MuiTypography-root': {
                                    color: 'sub.text',
                                    display: "block",
                                    width: '100%',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    '&:hover': {
                                        backgroundColor: 'sub.hover',
                                    }
                                }}} className="box">
                                <Typography fontSize={12}
                                            onClick={()=>{navigate("/faq")}}
                                >
                                    Questions
                                </Typography>
                                <Typography fontSize={12}
                                            onClick={()=>{navigate("/aboutus")}}
                                >
                                    About us
                                </Typography>
                                <Typography fontSize={12}
                                            onClick={()=>{navigate("/support")}}
                                >
                                    Support
                                </Typography>

                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
